import Http from '@/services/http';
import {
  DiagnosticsRequest,
  DiagnosticsResponse,
  DiagnosticsListPagedRequest,
  ChromatographyDiagnosticsListPagedResponse,
  PhysicalChemicalDiagnosticsListPagedResponse,
} from 'sigma-mappings';

const urls = {
  getDiagnostics: '/engenharia/chroma/diagnosticos',
  chromatographyDiagnosticsList: '/engenharia/cromatografia/diagnosticos/listagem',
  physicalChemicalDiagnosticsList: '/engenharia/fisico-quimico/diagnosticos/listagem',
  excel: '/engenharia/chroma/diagnosticos/exportar/excel',
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA009: data => data,
    },
  },
};

export default {
  getDiagnostics(payload) {
    const http = new Http();
    const mappedPayload = new DiagnosticsRequest(payload);
    return http.post(urls.getDiagnostics, mappedPayload).then(
      ({ data }) => data.map(item => new DiagnosticsResponse(item)),
    );
  },
  chromatographyDiagnosticsList(payload) {
    const http = new Http(error);
    const mappedPayload = new DiagnosticsListPagedRequest(payload);
    return http.post(urls.chromatographyDiagnosticsList, mappedPayload).then(
      ({ data }) => new ChromatographyDiagnosticsListPagedResponse(data),
    );
  },
  physicalChemicalDiagnosticsList(payload) {
    const http = new Http(error);
    const mappedPayload = new DiagnosticsListPagedRequest(payload);
    return http.post(urls.physicalChemicalDiagnosticsList, mappedPayload).then(
      ({ data }) => new PhysicalChemicalDiagnosticsListPagedResponse(data),
    );
  },
  /* istanbul ignore next */
  exportXlsx(payload) {
    const http = new Http({
      download: true,
      ...error,
    });
    const mappedPayload = new DiagnosticsListPagedRequest({ filter: payload });
    return http.post(urls.excel, mappedPayload).then(({ data }) => data);
  },
};
